import React, { useState } from 'react';
import { i18n } from 'utils/i18n';
import { dtm } from 'utils/analytics';
import { ANALYTICS } from 'constants';
import Button from 'components/Button';
import { propTypes } from './NoResultsPartnerDisplayProptypes';

const NoResultsPartnerDisplay = ({
  shouldShowCloseButton,
  handleHidePartnerResultsToggle,
  handleToggleShowPartnerLocations,
}) => {
  const [isShowingCloseBtn, setIsShowingCloseBtn] = useState(shouldShowCloseButton);

  const handleVisibility = () => {
    handleHidePartnerResultsToggle();
  };

  const handleClick = () => {
    handleToggleShowPartnerLocations();
    setIsShowingCloseBtn(true);
  };

  return (
    <div className='no-results-partner-display__container'>
      {isShowingCloseBtn && (
        <Button
          plain
          tabIndex='-1'
          onClick={handleVisibility}
          title={i18n('no_results_partner_close')}
          aria-label={i18n('no_results_partner_close')}
          className='no-results-partner-display__button'
        />
      )}
      <h3 className='no-results-partner-display__main-text'>{i18n('no_results_partner_main_text')}</h3>
      <p className='no-results-partner-display__sub-text'>{i18n('no_results_partner_sub_text')}</p>
      {(!isShowingCloseBtn || !shouldShowCloseButton) && (
        <Button
          data-dtm-track={dtm(ANALYTICS.UI_BUTTON, ANALYTICS.LOCATION, 'view_partner_locations')}
          className='button no-results-partner-display__view-partner-locations-button'
          onClick={handleClick}
        >
          {i18n('location_finder_view_partner_locations_button')}
        </Button>
      )}
    </div>
  );
};

NoResultsPartnerDisplay.propTypes = propTypes;

export default NoResultsPartnerDisplay;
